// B1.4: schedules domain methods (move-only from client.ts).
import { ApiClientCore, buildQueryString } from './http/core';

export class SchedulesApi extends ApiClientCore {
  // ─── Schedules ──────────────────────────────────────────────────────────────
  async getSchedules(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/schedules${buildQueryString(params)}`);
  }
  async getSchedule(id: number): Promise<any> {
    return this.get(`/api/v1/schedules/${id}`);
  }
  async getScheduleOperationalDiagnostics(): Promise<any> {
    return this.get('/api/v1/schedules/operational-diagnostics');
  }
  async createSchedule(data: any): Promise<any> {
    return this.post('/api/v1/schedules', data);
  }
  async createSchedulesBulk(data: any): Promise<{ schedules: any[]; created_count: number }> {
    return this.post('/api/v1/schedules/bulk', data);
  }
  async updateSchedule(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/schedules/${id}`, data);
  }
  async deleteSchedule(id: number): Promise<any> {
    return this.delete(`/api/v1/schedules/${id}`);
  }
  async duplicateSchedule(id: number, newName: string): Promise<any> {
    const result = await this.bulkActionSchedules({
      ids: [id],
      action: 'duplicate',
    });
    // Если нужно переименовать, делаем отдельный запрос
    if (result.new_ids && result.new_ids[0]) {
      await this.updateSchedule(result.new_ids[0], { name: newName });
    }
    return result;
  }
  async bulkActionSchedules(data: {
    ids: number[];
    action: 'activate' | 'deactivate' | 'delete' | 'duplicate';
  }): Promise<{
    success_count: number;
    failed_count: number;
    failed_ids: number[];
    errors: { id: number; error: string }[];
    new_ids?: number[];
  }> {
    return this.post('/api/v1/schedules/bulk-action', data);
  }
  async getUpcomingScheduleInstances(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/schedules/instances/upcoming${buildQueryString(params)}`);
  }
  async claimScheduleInstance(instanceId: number): Promise<any> {
    return this.post(`/api/v1/schedules/instances/${instanceId}/claim`);
  }
}
